import { waitForConditionToBeTrue } from '@thorborn/utils/index';

class Tracker {
  constructor() {
    this._debug = false;
  }

  get debug() {
    this._debug = true;

    return this;
  }

  allV2(eventName, parameters = {}) {
    // For this project we don't want to send any Google Analytics events since they use another
    // agency for that and they use native GTM.
    // this.googleAnalyticsV2(eventName, parameters);

    this.hotjarV2(eventName, {
      category: parameters.category,
      label: parameters.label,
    });
  }

  googleAnalyticsV2(eventName, parameters = {}) {
    waitForConditionToBeTrue(
      () => window.gtag,
      () => {
        const eventParams = {
          ...parameters,

          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
        };

        if (this._debug) {
          // We need to make sure that `debug_mode` is not set.
          // See: https://support.google.com/analytics/answer/7201382?hl=en-GB&utm_id=ad#zippy=%2Cgoogle-tag-gtagjs:~:text=To%20disable%20debug%20mode%2C%20exclude%20the%20%27debug_mode%27%20parameter%3B%20setting%20the%20parameter%20to%20false%20doesn%27t%20disable%20debug%20mode.
          eventParams.debug_mode = this._debug;
        }

        window.gtag('event', eventName, eventParams);
      },
    );
  }

  hotjarV2(eventName, { category, label } = {}) {
    waitForConditionToBeTrue(
      () => window.hj,
      () => {
        const eventNameParts = [eventName, category, label].filter((item) => item);

        if (eventNameParts.find((part) => !part.match(/^[a-zA-Z0-9_]+$/))) {
          throw new Error(
            'The event name can only contain alphanumeric characters (a-z, A-Z, 0-9) and underscores (_)',
          );
        }

        const name = eventNameParts.join('-');

        const limit = 250 - eventNameParts.length;

        if (name.length > limit) {
          throw new Error(
            `The event category, action and label must not exceed ${limit} characters`,
          );
        }

        if (this._debug) {
          // TODO: Does hotjar have a debug mode we can use instead?
          console.log('call window.hj', name);

          return;
        }

        window.hj('event', name);
      },
    );
  }

  /**
   * @deprecated - This method is deprecated since GA UA has been sunsetted. Use `allV2` instead.
   */
  all({ category, action, label, value }) {
    this.googleAnalytics({ category, action, label, value });
    this.hotjar({ category, action, label, value });
  }

  /**
   * @deprecated - This method is deprecated since GA UA has been sunsetted. Use `googleAnalyticsV2` instead.
   */
  googleAnalytics({ category, action, label, value }) {
    if (!window.ga) {
      console.warn('window.ga is not defined');

      return;
    }

    window.ga('send', 'event', category, action, label, value);
  }

  /**
   * @deprecated - This method is deprecated since GA UA has been sunsetted. Use `googleAnalyticsV2` instead.
   */
  hotjar({ category, action, label }) {
    const eventNameParts = [category, action, label].filter((item) => item);

    if (eventNameParts.find((part) => !part.match(/^[a-zA-Z0-9_]+$/))) {
      throw new Error(
        'The event name can only contain alphanumeric characters (a-z, A-Z, 0-9) and underscores (_)',
      );
    }

    const name = eventNameParts.join('-');

    const limit = 250 - eventNameParts.length;

    if (name.length > limit) {
      throw new Error(`The event category, action and label must not exceed ${limit} characters`);
    }

    if (!window.hj) {
      console.warn('window.hj is not defined');

      return;
    }

    window.hj('event', name);
  }
}

export default new Tracker();
